import { format } from 'date-fns';
import styled from 'styled-components';

import useDischargeCalendarCounts from '../hooks/useDischargeCalendarCounts';
import useMonthNavigation from '../hooks/useMonthNavigation';

import DayCell from './DayCell';

const WEEKDAY_LABELS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export default function MonthViewGrid() {
  const { calendarDays, isInCurrentMonth, startDate, endDate } = useMonthNavigation();
  const { data: counts = {}, isFetching } = useDischargeCalendarCounts({ startDate, endDate });

  return (
    <Container>
      <WeekdayHeader>
        {WEEKDAY_LABELS.map((day) => (
          <WeekdayLabel key={day}>{day}</WeekdayLabel>
        ))}
      </WeekdayHeader>
      <Grid data-cy='month-grid'>
        {calendarDays.map((date) => {
          const dateKey = format(date, 'yyyyMMdd');
          const dayCounts = counts[dateKey] ?? { medicare: 0, other: 0 };
          return (
            <DayCell
              key={dateKey}
              date={date}
              isOutsideMonth={!isInCurrentMonth(date)}
              counts={dayCounts}
              isLoading={isFetching}
            />
          );
        })}
      </Grid>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  border: 1px solid ${({ theme }) => theme.colors.black15};
  border-radius: 8px;
`;

const WeekdayHeader = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-bottom: 1px solid ${({ theme }) => theme.colors.black10};
`;

const WeekdayLabel = styled.div`
  padding: 12px 8px;
  font-size: 12px;
  font-weight: var(--font-weight-medium);
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  border-right: 1px solid ${({ theme }) => theme.colors.black10};

  &:last-child {
    border-right: none;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;
